import { client } from "Service/axios";
import { IUser } from "Shared/Types";

const USER_URL = 'users/';

class User {
  getUserList() {
    return client.get<IUser[]>(USER_URL);
  }
  getUser(id: number) {
    return client.get<IUser>(`${USER_URL}${id}`);
  }
  getCurrentUser() {
    return client.get<IUser>(`${USER_URL}me/`);
  }
}

export default User;
